import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { computed } from '@angular/core';
import { UserInterface } from '@core/interfaces/user.interface';
import { UserRole } from '@core/enums/user-role.enum';

type UserState = {
  user: UserInterface | null;
};

export const UserSignalStore = signalStore(
  { providedIn: 'root' },
  withState<UserState>({ user: null }),
  withComputed((store) => ({
    isSuperAdmin: computed(() => store.user()?.userRole === UserRole.SuperAdmin),
    isCompanyAdmin: computed(() => store.user()?.userRole === UserRole.CompanyAdmin),
    isCompanyUser: computed(() => store.user()?.userRole === UserRole.CompanyUser),
  })),
  withMethods((store) => ({
    setCurrentUser(userData: { data: UserInterface }): void {
      patchState(store, { user: userData.data });
    },
  })),
);
